<mat-card>
  <mat-toolbar>Insurances
    <span class="fill-remaining-space"></span>
    <button mat-icon-button matTooltip="Show/Hide search" aria-label="Show/hide search" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
    </button>
    <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="addInsurance()" matTooltip="New insurance" aria-label="New insurance" matTooltipClass="tooltip-style">
        <mat-icon color="primary" style="font-size:24px">add</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Export list" aria-label="Export list" matTooltipClass="tooltip-style" (click)="this.exportar()" style="float: right; margin-right: 0">
      <mat-icon color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
    </button>
  </mat-toolbar>
  
  <mat-card-content>
    <mcrit-gestio-insurances-filters
      *ngIf="showFilters"
      [validFilters]="insurancesFilters"
      (changeFilter)="computeActiveFilters($event)">
    </mcrit-gestio-insurances-filters>
    
    <table>
      <thead>
        <tr>
          <th class="actions-column-header">Actions</th>
          <th *ngFor="let field of tableFields; let i = index" (click)="cycleOrdering(field[0])" style="vertical-align: top; cursor: pointer;">
            {{field[1]}}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters[field[0]] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters[field[0]] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon>
          </th>
        </tr>
      </thead>
      
      <tbody *ngIf="insurancesData">
          <tr *ngFor="let insurance of insurancesData.rows;" class="table-data-row">
            <td class="actions-cell">
              <button mat-icon-button [matMenuTriggerFor]="actionMenu" 
              [matMenuTriggerData]="{ Id: insurance['plate'] }"
              matTooltip="Opcions"
              matTooltipClass="tooltip-style">
                <mat-icon color="primary">more_vert</mat-icon>
              </button>
            </td>
            <td *ngFor="let field of tableFields" (click)="editInsurance(insurance)" class="data-cell">
              {{ insurance[field[0]] }}
            </td>
          </tr>
      </tbody>
    </table>
  </mat-card-content>
  
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      Rows per page: {{listInsurancesService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="insurancesData">
      {{firstRegisterShown}} - {{lastRegisterShown}} de {{insurancesData.registers}} insurances
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>

<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>

<mat-menu #actionMenu="matMenu" xPosition="after">
  <ng-template matMenuContent let-id="Id">
    <button mat-menu-item (click)="go('accidents', id)">
      <mat-icon color="primary">car_crash</mat-icon>
      <span>Accidents</span>
    </button>
    <button mat-menu-item (click)="go('insurances', id)">
      <mat-icon color="primary">assignment_ind</mat-icon>
      <span>Insurances</span>
    </button>
    <button mat-menu-item (click)="go('licenses', id)">
      <mat-icon color="primary">description</mat-icon>
      <span>Licenses</span>
    </button>
    <button mat-menu-item (click)="go('inspections', id)">
      <mat-icon color="primary">engineering</mat-icon>
      <span>Inspections</span>
    </button>
    <button mat-menu-item (click)="go('vehicles', id)">
      <mat-icon color="primary">commute</mat-icon>
      <span>Vehicles</span>
    </button>
  </ng-template>
</mat-menu>